import "./utils/index";
import "./utils/scroll-config";
import productHover from "./modules/animation-product";
import accordionList from "./modules/animation-accordion";
import { onscrollAnimations } from "./modules/animations-onscroll";
import { onloadAnimations } from "./modules/animations-onload";
import teamSlider from "./modules/slider-team";
import Form from "./modules/form";
import tabs from "./modules/animations-tabs";
import toggleMenu from "./modules/toggle-menu";
import { plansScroll } from "./modules/scroll-plans";
import { numeratePolicy } from "./modules/policy-page";
import { welcomeAnimations } from "./modules/animations-welcome";
import reportsAjax from "./modules/report-ajax";
import loginForm from "./modules/form-login";
import logoutForm from "./modules/form-logout";
import purchaseForm from "./modules/form-purchase";

productHover();
accordionList();
onloadAnimations();
onscrollAnimations();
teamSlider();
Form();
tabs();
toggleMenu();
plansScroll();
numeratePolicy();
welcomeAnimations();
reportsAjax();
loginForm();
logoutForm();
purchaseForm();
